// eslint-disable-next-line no-shadow
export enum ChartTypeOptionsEnum {
  line = 'Line',
  bar = 'Bar',
  pie = 'Pie',
}

// eslint-disable-next-line no-shadow
export enum ChartCalculationOptionsEnum {
  cumulative = 'Cumulative',
  incremental = 'Incremental',
}

export type GoalSectionParamOptions =
  | 'tasks'
  | 'comments'
  | 'progress'
  | 'updates'

export type GoalDashboardTab = {
  count?: number
  label: string
  param: GoalSectionParamOptions
}

export type DataPointMap = Record<
  string,
  { goalToDimensionId: number; label: string; value: number }
>

export type DataPoint = {
  x: string
  y: number
}

export type SeriesData = {
  data: DataPoint[]
  title: string
}

export type Chart = {
  calculationType: string
  id: number
  target: number
  title: string
  unitOfMeasurement: string
  seriesData: SeriesData[]
}

export type Series = {
  data: {
    chart: Chart
  }
}

export type DimensionsData = {
  data: DataPoint[]
  goalToDimensionId: number
  label: string
}
